import React, { useRef } from 'react';
var VeltInlineCommentsSectionSortingDropdownContent = function (props) {
    var defaultCondition = props.defaultCondition, targetElementId = props.targetElementId, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content", { ref: ref, "target-element-id": targetElementId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltInlineCommentsSectionSortingDropdownContent;
